import _ from 'lodash';
import { PlainProgramScenario } from '../../models/Scenario';

export const isScenarioLinked = (
  scenarioId: number,
  totalPrograms: PlainProgramScenario[]
) =>
  totalPrograms
    .flatMap((_totalProgram) => _totalProgram?.linkedScenarios)
    .some((linkedScenario) => linkedScenario?.id === scenarioId);
